import {
  InputAdornment,
  InputProps as StandardInputProps,
  TextField,
} from "@mui/material";
import { FormikTouched } from "formik";
import { FormikErrors } from "formik/dist/types";
import { FunctionalComponent, h } from "preact";
import { fields, SolarDiverterForm } from "../form";

export const LookedUpField: FunctionalComponent<{
  fieldId: keyof SolarDiverterForm;
  form: {
    handleChange: any;
    values: Record<keyof SolarDiverterForm, any>;
    touched: FormikTouched<SolarDiverterForm>;
    errors: FormikErrors<SolarDiverterForm>;
  };
}> = ({ fieldId, form }) => {
  const fieldData = fields.find(({ id }) => id === fieldId);
  if (!fieldData) {
    throw new Error(`Cannot find field: ${fieldId}`);
  }

  const inputProps: Partial<StandardInputProps> = {
    sx: { mb: 1 },
    inputMode: "numeric",
    pattern: "[0-9]*",
  };
  if (fieldData.startAdornment) {
    inputProps.startAdornment = (
      <InputAdornment position="start">
        {fieldData.startAdornment}
      </InputAdornment>
    );
  }

  if (fieldData.endAdornment) {
    inputProps.endAdornment = (
      <InputAdornment position="end">{fieldData.endAdornment}</InputAdornment>
    );
  }
  return (
    <TextField
      sx={{ mb: 1 }}
      fullWidth
      id={fieldData.id}
      label={fieldData.label}
      name={fieldData.id}
      autoComplete="off"
      value={form.values[fieldId]}
      onChange={form.handleChange}
      error={Boolean(form.errors[fieldId])}
      helperText={form.errors[fieldId] || fieldData.hint}
      InputProps={inputProps}
    />
  );
};
